<template>
  <div class="jin-position-con">
    <div v-if="list.length" style="width: 100%;">
      <h3 v-if="kind && show">{{ kind.name }}</h3>

      <ul class="jin-position-warp">
        <li v-for="(item) in list" :key="item.id" class="jin-position-item" @click="onLink(item)">
          <div class="jin-position-item-info">
            <div class="jin-position-item-name">
              <span :class="item.urgent ? 'post-emer' : 'post-hot'" :data-name="attributesObj[item.attributes]">{{ item.name }}</span>
            </div>
            <span v-if="attributesObj[item.attributes] === '兼职'" class="salary">{{ `${item.min_salary } 元 / 小时 ` }}</span>

            <span v-else class="salary">{{ `${item.min_salary / 1000}k - ${item.max_salary / 1000}k ${ salaryType[item.salary_type] ? (' · ' + salaryType[item.salary_type]) : ''}` }}</span>
          </div>
          <div class="jin-position-item-details">
            <p>
              <span>{{ item.place || '广州' }}</span>
              <span v-if="item.experience">经验{{ item.experience.replace(',', '-') }}年</span>
              <span>{{ item.qualification }}</span>
              <span>{{ attributesObj[item.attributes] }}</span>
            </p>
            <p>
              发布日期：{{ dayjs(item.display_datetime).format('YYYY/MM/DD') }}
            </p>
          </div>
        </li>
      </ul>
      <div v-if="showPage" class="jin-pc jin-pagination">
        <el-pagination
          :current-page="page.page"
          :page-sizes="[10, 20, 50]"
          :page-size="page.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
      <div class="jin-m jin-m-pagination">
        <span v-if="total <= list.length">没有更多了</span>
        <span v-else @click="onLoad">点击查看更多</span>
      </div>
    </div>
    <None v-else />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { attributesObj, salaryType } from '@/views/option'

export default {
  props: {
    show: {
      type: Boolean,
      default: true
    },
    showPage: {
      type: Boolean,
      default: true
    },
    isPage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      attributesObj,
      salaryType,
      page: {
        page_size: 10,
        page: 1
      }
    }
  },
  computed: {
    ...mapGetters([
      'list',
      'kind',
      'total',
      'category',
      'keyWords'
    ]),
    attributes() {
      return this.$route.query.attributes
    }
  },
  watch: {
    attributes() {
      this.SET_CATEGORY_TITLE({
        name: '全部职位',
        id: ''
      })
      this.page.page = 1
      this.RESET_LIST()
      // this.onLoad()
    }
  },
  created() {
    if (this.showPage) {
      this.page.page = 1
    }
  },
  methods: {
    ...mapActions('position', ['GET_LIST']),
    ...mapMutations('position', ['RESET_LIST', 'SET_CATEGORY_TITLE']),
    onLink(item) {
      const curr = this.category.find(v => v.id === item.category_id)
      this.$router.push({
        path: '/list/info',
        query: {
          id: item.id,
          title: this.kind.name || curr ? curr.name : '',
          category_id: item.category_id,
          category_name: item.name,
          attributes: item.attributes
        }
      })
    },
    handleMobileList() {
      this.page.page = 1
      this.RESET_LIST()
      this.onLoad()
    },
    handlePcList() {
      if (this.IsPC) {
        this.page.page = 1
        this.RESET_LIST()
        this.getList()
      }
    },
    async onLoad() {
      await this.getList()
      this.page.page++
    },
    async getList() {
      const params = { category_id: this.kind.id, ...this.page, attributes: Number(this.attributes) === 1 ? 1 : 0, key_words: this.keyWords }
      await this.GET_LIST(params)
    },
    handleSizeChange(size) {
      this.page.page_size = size
      this.getList()
    },
    handleCurrentChange(no) {
      this.page.page = no
      this.getList()
    }
  }
}
</script>
